import { render, staticRenderFns } from "./patientTraval.vue?vue&type=template&id=7a97e62f&scoped=true&"
import script from "./patientTraval.vue?vue&type=script&lang=js&"
export * from "./patientTraval.vue?vue&type=script&lang=js&"
import style0 from "./patientTraval.vue?vue&type=style&index=0&id=7a97e62f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a97e62f",
  null
  
)

export default component.exports